// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".responsive-container{position:relative;width:90%;margin:auto}@media(min-width: 960px){.responsive-container{padding:0;margin-block:0;max-width:1260px;width:100%}}.responsive-container--full-width{padding:0;max-width:none;max-width:initial;margin-inline:auto}@media(min-width: 960px){.responsive-container--full-width{margin:0;margin:initial}}.responsive-container--small{max-width:620px}.responsive-container--medium{max-width:940px}.responsive-container--large{max-width:1260px}", ""]);
// Exports
module.exports = exports;
